import {twMerge} from '@sdox/utils'

import type {ComponentProps, PropsWithChildren} from 'react'

export interface PdfViewerProps {
  src: string
  title: string
}

/**
 * The `PdfViewer` simply displays a pdf in the native pdf viewer of the browser.
 */
export const PdfViewer = ({
  className,
  src,
  /**
   * Each `iFrame` needs a unique title
   */
  title,
  ...restProps
}: PropsWithChildren<PdfViewerProps & ComponentProps<'object'>>) => (
  <object
    data={src}
    type={'application/pdf'}
    className={twMerge('w-full object-contain', className)}
    style={{height: '80vh'}}
    {...restProps}
  >
    <iframe
      title={title}
      className={'h-screen w-screen'}
      src={src}
    />
  </object>
)
